import React, { useState } from 'react';
import { Dropdown, InputGroupProps, ListGroup } from "react-bootstrap";
import { FieldCondition, MenuItemCategory, MenuItemType, NavObjectType } from "../Components/navigationTypes";
import { RPWDataReader, getDataReader } from '../livedataFuncs'
import { IndicatorBadgeType } from "./sideTypes";
import { runInnerFunction } from "../compatManager";
import { useAppSelector } from "../redux/hooks";
import { useDispatch } from 'react-redux';
import { lddStateObject, setLawyerListState } from '../redux/reducer';

interface IProps {
    nav: (obj: NavObjectType) => void;
    menuType?: MenuItemCategory,
    buyer?: Record<string, string>,
    title?: boolean,
    agreement?: boolean,
    final?: boolean,
    numOfTabs?: number,
    label: string,
    indicatorList?: Array<IndicatorBadgeType>,
    warn?: boolean,
    children?: any,
    link: NavObjectType,
    subIndex?: string,
    dropdownOptions?: Array<MenuItemType>,
    requiredFields?: FieldCondition[],
    symbol?: "copyright" | "trademark" | "registered",
    page?: NavObjectType,
    icon?: string,
    badge?: boolean,
    customLabel?: string,
}

const labelPairs = {
    "Client Intake Information": "addIntakeFields",
    "Document Exchange": "documentsRequested",
    "Client Retainer": "retainerAgreement",
    "Identity Verification": "clientConnectId",
    "Source of Funds": "sourceOfFunds",
    "Manage Session": "remoteClosingCalls",
}

export const MenuItem = (props: IProps) => {
    const dispatch = useDispatch();
    const label = props.label;
    const [showCollapseMenu, setShowCollapseMenu] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);

    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const DataReaderObj: RPWDataReader = getDataReader(livedataRootContainer.dataRoot);
    const dashFields = DataReaderObj.getDashboardFields();
    const topLevel = [MenuItemCategory.TopLevel, MenuItemCategory.Property, MenuItemCategory.LawyerList].indexOf(props.menuType) > -1;
    const solicitorTargetNode = props.link?.actionParam === "VendorSolicitor" ? "VendorSolicitor" : "Solicitor";
    const hasExplicitSolicitorTarget = props.link?.actionParam === "VendorSolicitor" || props.link?.actionParam === "Solicitor";

    const handleAddIntakeInformation = async () => {
        try {
            DataReaderObj.updateIntakeInformation(labelPairs[label], true);
            setForceUpdate(forceUpdate + 1);
        } catch (e) {
            alert(`Error in updating intake field value: ${e.message || e}`)
        }
    };
    
    return (
        <>
            <ListGroup.Item
                className={ topLevel ? "main-item optionsHover" : "sub-item optionsHover" }
                eventKey={`${props.link?.controller?.tabName}-${props.link?.controller?.tabNumber}-${props.link?.actionParam}-${label}`}
                active={
                    (
                        props.page && props.page.label === label &&
                        props.page.controller?.tabNumber === props.link?.controller?.tabNumber
                    ) ||
                    (
                        props.menuType === MenuItemCategory.LawyerList &&
                        props.page && props.page.label === label &&
                        props.page.controller?.tabName === props.link?.controller?.tabName &&
                        (!props.link?.actionParam || props.page.actionParam === props.link.actionParam)
                    ) ||
                    (
                        props.page && props.page.reactFrame === 'builderesign' && 
                        label.includes('e-signing') && 
                        !props.page.label.includes('Documents for e-signing')
                    )
                }
                onClick={() => {
                    if (props.menuType === MenuItemCategory.LawyerList && hasExplicitSolicitorTarget && !props.badge) {
                        dispatch(setLawyerListState(true, { solicitorTargetNode }));
                        return;
                    }
                    if (labelPairs.hasOwnProperty(label)) {
                        handleAddIntakeInformation();
                    }
                    if (props.menuType === MenuItemCategory.WindowOpen &&
                        (props.link.component === "" && typeof props.link.url === "string")) {
                        window.open(props.link.url);
                    } else if (props.link) props.nav({ label: label, ...props.link });
                    // need a better condition for this
                    if (props.menuType === MenuItemCategory.LawyerList && !props.badge) {
                        dispatch(setLawyerListState(true));
                    }
                    if (props.menuType === MenuItemCategory.Dropdown) {
                        setShowCollapseMenu(!showCollapseMenu);
                    }
                }}>
                <MenuItemRow 
                    def={props} 
                    label={label} 
                    extra={MenuItemExtras(props, showCollapseMenu, setShowCollapseMenu)} 
                    symbol={props.symbol} 
                    dashFields={dashFields} 
                    icon={props.icon} 
                    topLevel={topLevel}
                    customLabel={props.customLabel}
                />
                
                {props.children}
            </ListGroup.Item>
            
            {props.menuType === MenuItemCategory.Dropdown && showCollapseMenu &&
                <Dropdown show={showCollapseMenu} drop="end">
                    <Dropdown.Menu show rootCloseEvent='click'>
                        {props.dropdownOptions.map((option, mapindex) => {
                            return (
                                <Dropdown.Item  
                                    key={`${option.label}-${mapindex}`}
                                    onClick={() => { 
                                        if (typeof option.navigate.url === "string") window.open(option.navigate.url) 
                                    }}
                                >
                                    <span>{option.label}</span>
                                    <i className="fa-regular fa-arrow-up-right"></i>
                                </Dropdown.Item>
                            )
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            }
        </>

    );
}

const MenuItemExtras = (props: IProps, showCollapseMenu: boolean, setShowCollapseMenu: React.Dispatch<React.SetStateAction<boolean>>) => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const processor: RPWDataReader = getDataReader(livedataRootContainer?.dataRoot);

    switch (props.menuType) {
        case MenuItemCategory.Person:
            return (
                <span className="optionsContainer">
                    {((props.link.controller.tabName === "TransfereeDetails" && processor.getPSM() !== "S") || (props.link.controller.tabName === "TransferorDetails" && processor.getPSM() === "S")) &&
                        <i onClick={(e) => { e.stopPropagation(); props.nav({ ...props.link, scrollToId: processor.getPSM() === "S" ? "ReactCompatShellPopupHeaderSale" : "ReactCompatShellPopupHeader" }) }} className="fa-solid fa-id-card optionItem"></i>
                    }
                    <span className="optionItem">{MoveUpDown(props, processor)}</span>
                </span>
            )
        case MenuItemCategory.Property:
            return (
                <span className="optionsContainer ">
                    {props.label === 'Extra Properties' && (
                        <span className="item-subtitle text-truncate">{processor.getExtraPropertyNodesLength()}</span>
                    )}
                </span>
            );
        case MenuItemCategory.LawyerList:
            const solicitorTargetNode = props.link?.actionParam === "VendorSolicitor" ? "VendorSolicitor" : "Solicitor";
            const lawyerName = solicitorTargetNode === "VendorSolicitor"
                ? processor.getVendorLawyerName()
                : processor.getOtherSideLawyerName();
            return (
                <>
                    <span className="item-subtitle text-truncate">{lawyerName}</span>
                    <span className="optionsContainer">
                        <span className="optionItem">{ChangeLawyer(solicitorTargetNode)}</span>
                    </span>
                </>
            )
        case MenuItemCategory.AdditionalParties:
            return (
                props.indicatorList.map((badge) => (
                    <React.Fragment key={badge.label + props.label + props.subIndex}>
                        <span className="item-subtitle text-truncate">{badge.label}</span>
                        <span className="optionsContainer" key={badge.label + props.label + props.subIndex}>
                            <span className="optionItem">{ChangeAdditionalParty(props, badge.label)}</span>
                        </span>
                    </React.Fragment>
                ))
            );
        case MenuItemCategory.Dropdown:
            return (
                <span className="optionsContainer">
                    {showCollapseMenu ?
                        <i className="fa-solid fa-caret-up" onClick={() => setShowCollapseMenu(!showCollapseMenu)}></i> :
                        <i className="fa-solid fa-caret-down" onClick={() => setShowCollapseMenu(!showCollapseMenu)}></i>
                    }
                </span>
            )
        case MenuItemCategory.WindowOpen:
            return (
                <i className="fa-regular fa-arrow-up-right"></i>
            )
        default:
            return (
                <>
                    {props.indicatorList.map((badge) => {
                        const label = badge.label;
                        const hasOptions = (label === "VTB" || label === "New");
                        return (
                            <React.Fragment key={badge.label + props.label + props.subIndex}>
                                <span className={`item-subtitle`}>{label}</span>
                                <span key={badge.label + props.label + props.subIndex} className="optionsContainer">
                                    {hasOptions && <span className="optionItem">{MoveUpDown(props, processor)}</span>}
                                </span>
                            </React.Fragment>
                        )
                    })}
                </>
            )
    }
}

const MenuItemRow = (props: {
    def: any,
    label: string,
    extra?: any,
    symbol: "copyright" | "trademark" | "registered",
    dashFields: any
    icon: string,
    topLevel: boolean,
    customLabel?: string,
}) => {

    const indicatorShowCondition = (
        props.label === "+ Lawyer"
        || props.label === "+ Title Insurance"
        || props.label === "+ Lender"
    );

    const missingInfoCondition = ( 
        props.label === "+ Lender"
    );

    const displayLabel = props.customLabel > ""? props.customLabel:props.label;

    let showPlusIcon = false;

    if (props.dashFields) {
        showPlusIcon = labelPairs[props.label] && props.dashFields[labelPairs[props.label]] === "false";
    }
    return (
        <>  
        <i className={`indicator indicator-warn ${indicatorShowCondition ? "show" : ""}`} /> 
            {props.topLevel ?
                <MenuItemCard label={displayLabel} icon={props.icon} extra={props.extra}/>
                :
                <>
                    <span className={`item-name ${missingInfoCondition || showPlusIcon || indicatorShowCondition === true ? "missing-info" : ""}`}>
                        {showPlusIcon && '+ '}
                        {props.label}
                        {props.symbol &&
                            <sup>
                                {props.symbol === "copyright" ? <>&#169;</> :
                                    props.symbol === "registered" ? <>&#174;</> :
                                        props.symbol === "trademark" ? <>&#8482;</> :
                                            null}
                            </sup>
                        }
                    </span>
                    
                    {props.extra}

                    {indicatorShowCondition && (
                        <i className="fa-solid fa-circle-exclamation status-warning" />
                    )}
                </>
            }
        </>
    )
}

const MenuItemCard = (props:{label: string, icon: string, extra: any}) => {
    return (
        <>
            <i className={`fal ${props.icon} item-icon`}/>
            <h4 className="item-name">
                {props.label}
            </h4>
            {props.extra}
        </>
    )
}

function ChangeLawyer(solicitorTargetNode: string) {
    const dispatch = useDispatch();
    return (
        <Dropdown drop='end'>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
                <Dropdown.Header>Options</Dropdown.Header>
                <Dropdown.Item onClick={() => {
                    runInnerFunction('ReactShell.reactDeleteSolicitor', solicitorTargetNode === "Solicitor" ? null : solicitorTargetNode);
                }}>
                    Remove
                </Dropdown.Item>
                <Dropdown.Item onClick={
                    () => {
                        dispatch(setLawyerListState(true, { solicitorTargetNode }));
                    }
                }>
                    Change
                </Dropdown.Item>
                <Dropdown.Item onClick={() => {
                    runInnerFunction('ReactShell.ReactExportInfoToRepository', solicitorTargetNode);
                }}>
                    Update Database
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

function ChangeAdditionalParty(props: IProps, label: string) {
    const type = props.link.controller.tabName.toString();
    let nodeName = "";
    switch (label) {
        case "Referral":
        case "Water Company":
            nodeName = label;
            break;
        case "Relocation Co.":
            nodeName = "Relocation Company";
            break;
        default:
            nodeName = type;
    }

    return (
        <Dropdown drop='end'>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
            <Dropdown.Header>Options</Dropdown.Header>
                <Dropdown.Item
                    onClick={() => {
                        runInnerFunction('ReactShell.reactDeleteAdditiontalParty', nodeName);
                    }}>
                    Remove
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

function MoveUpDown(props: IProps, processor: RPWDataReader) {
    return (
        <Dropdown drop='end'>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
            <Dropdown.Header>Options</Dropdown.Header>
                <Dropdown.Item
                    onClick={(e) => {
                        if (props.link.controller.tabNumber !== 1) {
                            const type = props.link.controller.tabName
                            const index = Number(props.link.controller.tabNumber) - 1
                            processor.moveNodeUp(type, index);
                            switch (type) {
                                case "Mortgages":
                                    break;
                                case "TransferorDetails":
                                case "TransfereeDetails":
                                default:
                                    props.nav({ ...props.link, controller: { tabName: type, tabNumber: index } })
                                    break;
                            }
                        }
                        e.stopPropagation();
                    }}
                    disabled={props.link.controller.tabNumber === 1}>Move Up</Dropdown.Item>
                <Dropdown.Item
                    onClick={(e) => {
                        if (props.link.controller.tabNumber !== props.numOfTabs) {
                            const type = props.link.controller.tabName
                            const index = Number(props.link.controller.tabNumber) - 1
                            processor.moveNodeDown(type, index);
                            switch (type) {
                                case "Mortgages":
                                    break;
                                case "TransferorDetails":
                                case "TransfereeDetails":
                                default:
                                    props.nav({ ...props.link, controller: { tabName: type, tabNumber: index + 2 } })
                                    break;
                            }
                        }
                        e.stopPropagation();
                    }}
                    disabled={props.final || props.link.controller.tabNumber === props.numOfTabs}>Move Down</Dropdown.Item>
                <Dropdown.Item
                    onClick={(e) => {
                        const type = props.link.controller.tabName
                        const index = Number(props.link.controller.tabNumber) - 1
                        processor.deleteNode(type, index);
                        e.stopPropagation();
                        if (Number(props.link.controller.tabNumber) > 1) {
                            const navobj = props.link;
                            navobj.controller.tabNumber--;
                            props.nav(navobj);
                        }
                    }}>Remove</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

const CustomToggle = React.forwardRef<HTMLInputElement, InputGroupProps>(
    ({ children, onClick }, ref) => (
        <i className={"fa-solid fa-ellipsis-vertical"}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClick(e);
            }}>
            {children}
        </i>
    ))
